import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  getData (context) {
    let path = 'client'
    Vue.axios.get(path)
      .then(response => {
        for (let index = 0; index < response.data.length; index++) {
          addClientIdsField(response.data[index])
        }

        context.commit('SET_CLIENTLIST', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },

  /**
   * @param context
   */
  async getClients (context) {
    let clientList = await Vue.axios.get('client')
      .then(response => {
        // context.commit('SET_CLIENTLIST', response.data)
        return JSON.parse(JSON.stringify(response.data)).sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      })
      .catch(error => {
        console.log(error)
      })
    return clientList
  },

  addClient (context, client) {
    context.commit('ADD_CLIENT', client)
  },
  selectClient (context, client) {
    context.commit('ADD_SELECTED', client)
  },

  async getClientData (context, params) {
    let path = 'client/' + params.data.clientId
    let populate = []
    let requestParam

    if (params.options && params.options.populate && !params.options.populate) {
      populate = []
      requestParam = { params: { populate: populate.join(',') } }
    }

    let client = await Vue.axios.get(path, requestParam)
      .then(response => {
        addClientIdsField(response.data)

        context.commit('UPDATE_CLIENT_IN_CLIENTLIST', response.data)
        return JSON.parse(JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(error)
      })
    return client
  },

  async createClientData (context, params) {
    let response
    delete params.data.id
    delete params.data.Networks
    delete params.data.NetworkIds
    delete params.data.Users
    delete params.data.UserIds

    await Vue.axios.post('client', params.data)
      .then(response => {
        addClientIdsField(response.data)

        context.commit('ADD_CLIENT_TO_CLIENTLIST', response.data)
        response = response.data
      })
      .catch(error => {
        console.log(error)
        throw error
      })

    return response
  },

  async updateClientData (context, params) {
    let response
    delete params.data.Networks
    delete params.data.NetworkIds
    delete params.data.Users
    delete params.data.UserIds

    await Vue.axios.patch('client/' + params.data.id, params.data)
      .then(response => {
        addClientIdsField(response.data)

        context.commit('UPDATE_CLIENT_IN_CLIENTLIST', response.data)
        response = response.data
      })
      .catch(error => {
        console.log(error)
        throw error
      })

    return response
  }
}

let addClientIdsField = function (clientData) {
  clientData.NetworkIds = clientData.Networks.map(item => item.id)
  clientData.UserIds = clientData.Users.map(item => item.id)
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/client/client.actions.js
// module id = null
// module chunks = 